import { memo } from 'react';
import styled from 'styled-components';
import SkeletonBox from 'conversations-skeleton-state/components/SkeletonBox';
import { flexColumnStyles } from '../constants/flexColumnStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoadingWrapper = styled.div.withConfig({
  displayName: "EditorLoadingState__LoadingWrapper",
  componentId: "qt6xkh-0"
})(["", " flex-grow:1;"], flexColumnStyles);
const ToolbarSkeletonBox = styled(SkeletonBox).withConfig({
  displayName: "EditorLoadingState__ToolbarSkeletonBox",
  componentId: "qt6xkh-1"
})(["display:flex;padding-right:15px;justify-content:flex-end;align-items:center;flex-shrink:0;"]);
const EditorBodyWrapper = styled(SkeletonBox).withConfig({
  displayName: "EditorLoadingState__EditorBodyWrapper",
  componentId: "qt6xkh-2"
})(["flex-grow:1;padding:20px;display:flex;align-items:stretch;"]);
const EditorText = styled(SkeletonBox).withConfig({
  displayName: "EditorLoadingState__EditorText",
  componentId: "qt6xkh-3"
})(["flex-grow:1;height:auto;min-height:15px;"]);
const EditorLoadingState = /*#__PURE__*/memo(({
  minHeight
}) => {
  return /*#__PURE__*/_jsxs(LoadingWrapper, {
    children: [/*#__PURE__*/_jsx(EditorBodyWrapper, {
      use: "blank",
      width: "100%",
      height: minHeight,
      children: /*#__PURE__*/_jsx(EditorText, {})
    }), /*#__PURE__*/_jsx(ToolbarSkeletonBox, {
      width: "100%",
      height: "50px",
      children: /*#__PURE__*/_jsx(SkeletonBox, {
        height: "34px",
        width: "90px",
        use: "blank"
      })
    })]
  });
});
EditorLoadingState.displayName = 'EditorLoadingState';
export default EditorLoadingState;